import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  BuildIcon,
  DesignIcon,
  LaunchIcon,
  MaintenanceIcon,
  PlaneIcon,
  TestIcon,
} from "../../../app-constants";
import HtmlParser from "react-html-parser";
import BgImg from "../../images/services-usa/digital-marketing/digi_workflow.webp";

import { Link } from "gatsby";

const WorkFlow = [
  {
    logo: PlaneIcon,
    title: "Initial Strategy<br/> Consultation",
    description:
      "Evaluate business goals and target audience with a detailed strategy session.",
    count: "01",
  },
  {
    logo: DesignIcon,
    title: "Comprehensive Audit &<br/> Analysis",
    description:
      "Conduct in-depth SEO, SEM, and content audits to identify performance gaps.",
    count: "02",
  },
  {
    logo: BuildIcon,
    title: "Customized<br/> Campaign Planning",
    description:
      "Develop tailored marketing campaigns based on data insights and business objectives.",
    count: "03",
  },
  {
    logo: TestIcon,
    title: "Execution &<br/> Implementation",
    description:
      "Deploy targeted marketing tactics with precision and technical expertise.",
    count: "04",
  },
  {
    logo: LaunchIcon,
    title: "Continuous Monitoring<br/> & Optimization",
    description:
      "Track performance metrics, refine strategies, and optimize campaigns in real-time.",
    count: "05",
  },
  {
    logo: MaintenanceIcon,
    title: "Reporting &<br/> Sustainable Growth",
    description:
      "Provide detailed reports and ensure ongoing growth with adaptive marketing solutions.",
    count: "06",
  },
];
const Workflow = () => {
  return (
    <div
      className="workflow digital_marketing_flow p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={7}
            xxl={6}
            className="m-auto text-center"
          >
            <h2>
              Our Strategic, Result-Driven Digital Marketing{" "}
              <span>Workflow</span>
            </h2>
            <p>
              We deliver measurable results through a proven, data-driven
              approach for sustainable growth and continuous optimization. Join
              the ranks of our successful clients by leveraging our specialized
              digital marketing strategies.
            </p>
          </Col>
        </Row>
        <Row className="workflow_secion">
          {WorkFlow.map((item, index) => (
            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="mb-4">
              <div className="workflow_items">
                <div className="item_name">
                  <span>{item.count}</span>
                  {HtmlParser(item.title)}
                  <div className="item_icon"> {item.logo}</div>
                </div>
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center mt-3 mt-md-4"
          >
            <Link
              style={{ background: "#f47a1f", color: "#fff" }}
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Talk To Our Experts
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Workflow;
